import './Home.css'
import React, { useContext, useEffect, useState } from 'react'
import Message from './Message'
import { ChatContext } from '../../context/ChatContext'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../../config'
import { AuthContext } from '../../context/AuthContext'

const Messages = () => {
  const [messages, setMessages] = useState([])
  const { data } = useContext(ChatContext)
  const { curUser } = useContext(AuthContext)

  useEffect(() => {
    const unsubmit = onSnapshot(doc(db, 'groups', data.groupId), (doc) => {
      doc.exists() && setMessages(doc.data().message)
    })

    return () => {
      unsubmit()
    }
  }, [data.groupId])

  useEffect(() => {
    if (
      messages.length &&
      messages.slice(-1)[0].sender !== curUser.displayName
    ) {
      var notification = new Notification(messages.slice(-1)[0].text)
    }
  }, [messages, curUser])

  return (
    <div className="messages">
      {messages.map((m) => (
        <Message message={m} key={m.id} />
      ))}
    </div>
  )
}

export default Messages
